import {enhanceEndpoints} from '../api';

export const {
    useGetApiV1UnderwritingPathsQuery,
    useGetApiV1UnderwritingPathsByPathIdQuery,
    usePostApiV1UnderwritingPathsByPathIdMutation,
    usePostApiV1UnderwritingPathsMutation,
    useDeleteApiV1UnderwritingPathsByPathIdMutation,
} = enhanceEndpoints;
